module.exports = __webpack_public_path__ + "static/step4-5801bf671ad3dda9b9074eb5bb151e5e.svg";